module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado4",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredApps,
      "filterable": true,
      "label": "nombreApp",
      "placeholder": "SELECCIONAR APLICACIÓN"
    },
    on: {
      "input": _vm.selectApp
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                      Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                    ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdApp),
      callback: function($$v) {
        _vm.selectedIdApp = $$v
      },
      expression: "selectedIdApp"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rols), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-green",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalOperaciones"
      },
      on: {
        "click": function($event) {
          return _vm.verOperaciones(item)
        }
      }
    }, [_vm._v("V")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'rol_detalle' /*, params: { idRol: item.idRol }*/
        }
      }
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      on: {
        "click": function($event) {
          return _vm.enviar(item, _vm.selectedIdApp)
        }
      }
    }, [_vm._v("D")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_vm._v("\n                      Descripción:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rol.descripcion),
      expression: "rol.descripcion"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rol.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rol, "descripcion", $event.target.value)
      }
    }
  }), _c('br'), _vm._v("\n                      Aplicación:"), _c('br'), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado5",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredApps,
      "filterable": true,
      "label": "nombreApp",
      "placeholder": "Seleccionar Aplicación"
    },
    on: {
      "input": _vm.selectApp
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                          Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                        ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdApp),
      callback: function($$v) {
        _vm.selectedIdApp = $$v
      },
      expression: "selectedIdApp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.rol.descripcion,
      "title": !_vm.rol.descripcion ? 'Si desea guardar, complete el campo Descripción' : ''
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v(" Guardar\n                        Cambios")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se anulará el rol " + _vm._s(_vm.rol.descripcion) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Anular Rol")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalOperaciones",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("OPERACIONES POR ROL: " + _vm._s(_vm.rol.descripcion) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-md-12 fs-12"
  }, [_vm._v("\n                          Operación :\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opeByRol.idOperacion),
      expression: "opeByRol.idOperacion"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "disabled": _vm.opeByApp.length === 0
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.opeByRol, "idOperacion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.opeByApp.length > 0) ? [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Seleccionar Operación")]), _vm._v(" "), _vm._l((_vm.opeByApp), function(app) {
    return _c('option', {
      domProps: {
        "value": app.idOperacion
      }
    }, [_vm._v("\n                                " + _vm._s(app.descripcion) + "\n                              ")])
  })] : [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("No hay operaciones disponibles\n                              ")])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 m-t-12"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.mergeOpeByRol(_vm.rol.idRol)
      }
    }
  }, [_vm._v("AGREGAR +")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.error.desError) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tbRols"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.opeXRol), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.anularOpeByRol(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE ROLES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fuente col-xs-12"
  }, [_c('strong', [_vm._v("APLICACIÓN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "URL",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "OPERACIONES",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                          OPERACIONES\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                          DETALLE\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEA ANULAR EL ROL?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM\n                                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3b91c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Roles.vue
// module id = 330
// module chunks = 1